module.exports = require("core-js/library/fn/symbol");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/symbol.js
// module id = 211
// module chunks = 35783957827783 52252321336229